// ─── API Error Codes ─────────────────────────────
// Every error code the backend can return must be listed here.
// This schema is the single source of truth for the entire app.
// ────────────────────────────────────────────────────────────────────

export const API_ERROR_CODES = [
  "GetRestaurant.DBError",
  "GetRestaurant.NotFound",
  "UpdateUserRestaurant.DBError",
  "UpdateUserRestaurant.Forbidden",
  "UpdateUserRestaurant.NotFound",
  "ListCoursesV2.DBError",
  "ProposeCourseV2.CourseNotFound",
  "ProposeCourseV2.RestaurantNotFound",
  "ProposeCourseV2.IncompleteCourse",
  "ProposeCourseV2.VersionConflict",
  "ProposeCourseV2.ProposalConflict",
  "ProposeCourseV2.DBError",
  "GetCourseV2History.CourseNotFound",
  "GetCourseV2History.DBError",
  "SuggestCourseV2.Unavailable",
  "TranslateCourseV2.Unavailable",
  "CourseAvailability.CourseNotFound",
  "CourseAvailability.RuleNotFound",
  "CourseAvailability.ExceptionNotFound",
  "CourseAvailability.InvalidDates",
  "CourseAvailability.DBError",
  // Pipeline codes, shared by every backend handler.
  "FORBIDDEN",
  "INVALID_REQUEST_BODY",
] as const

/** Error codes for authorizer errors. */
export const AUTHORIZER_ERROR_CODES = ["Authorizer.Unauthorized", "Authorizer.Forbidden"] as const

/** Fallback code used client-side when API error payloads are malformed or unknown. */
export const UNKNOWN_API_ERROR_CODE = "UnknownError" as const

/** Union of all backend-defined API error codes. Derived from {@link API_ERROR_CODES}. */
export type TApiErrorCode = (typeof API_ERROR_CODES)[number]

/** Union of all authorizer error codes. Derived from {@link AUTHORIZER_ERROR_CODES}. */
export type TAuthorizerErrorCode = (typeof AUTHORIZER_ERROR_CODES)[number]

/** Fallback API code type used by the client only. */
export type TUnknownApiErrorCode = typeof UNKNOWN_API_ERROR_CODE

/** Any API code the frontend can emit/handle (backend + authorizer + client fallback). */
export type TClientApiErrorCode = TApiErrorCode | TAuthorizerErrorCode | TUnknownApiErrorCode
